import { render, staticRenderFns } from "./GuWeiInvitationRecord.vue?vue&type=template&id=4bf45b6a&scoped=true"
import script from "./GuWeiInvitationRecord.vue?vue&type=script&lang=js"
export * from "./GuWeiInvitationRecord.vue?vue&type=script&lang=js"
import style0 from "./GuWeiInvitationRecord.vue?vue&type=style&index=0&id=4bf45b6a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bf45b6a",
  null
  
)

export default component.exports